import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@env/environment';
import { icons } from './shared/sidebar/sidebar.icon';

@Injectable()
export class AppGlobals {
  headers = new HttpHeaders({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Origin': '*'
  });
  apiUrl = {
    authentication: environment.authentication.url + environment.authentication.path,
    dashboard: environment.dashboard.url + environment.dashboard.path,
    invoice: environment.invoice.url + environment.invoice.path,
    invoiceV2: environment.invoice.url + environment.invoice.pathV2,
    metadata: environment.metadata.url + environment.metadata.path,
    payment: environment.payment.url + environment.payment.path,
    pushtopetpooja: environment.pushtopetpooja.url + environment.pushtopetpooja.path,
    tally: environment.tally.url + environment.tally.path
  };
  bypassApiUrl = {
    invoice: environment.invoice.bypassUrl + environment.invoice.bypassPath,
    payment: environment.payment.bypassUrl + environment.payment.bypassPath
  };
  minPasswordLength = 8;
  loginMinPasswordLength = 6;
  otpLength = 6;
  regex = {
    email: new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
    mobile: new RegExp(/^\d{10}$/),
    number: new RegExp(/^(?=.*?\d)/),
    numberOnly: new RegExp(/^\d+(\.\d+)?$/),
    lowerCase: new RegExp(/^(?=[^a-z]*[a-z])/),
    upperCase: new RegExp(/^(?=[^A-Z]*[A-Z])/),
    pan: new RegExp(/^[A-Z]{3}[PCHABGJLFT][A-Z]\d{4}[A-Z]$/),
    gst: new RegExp(/^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Za-z]{1}[Z]{1}[0-9A-Za-z]{1})$/),
    symbol: new RegExp(/^(?=.*?[#?!@$%^&*-])/),
    password: new RegExp(/^(?!.*\s)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).+$/),
    length: (min?: number, max?: number) => new RegExp('^.{' + (min ?? '') + ',' + (max ?? '') + '}$'),
    name: new RegExp(/^[a-z\s]+$/i),
    onlyCharacter: new RegExp(/[a-zA-Z\s]+/),
    passwordEmail: new RegExp(/^(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}|\d{10})$/),
    fieldName: new RegExp(/^[a-z0-9\s!@#$%^&*()\-_+={}[\]:;"'<,>.?\/~`₹\|]+$/i),
    fieldNameSpecialCharacters: '!@#$%^&*()-_+={}[]:;"\'<,>.?/~`₹\|',
    date: new RegExp(/^\d{4}-\d{2}-\d{2}$/),
    companyName: new RegExp(/^(?!\s*$)[\w&@*.'()\-\s]+$/),
    Voucher: new RegExp(/^[a-zA-Z0-9]{3}$/),
    fullname: new RegExp(/^(?!\s*$)[a-zA-Z0-9\s]+$/i),
    cgstRate: new RegExp(/\bcgst\s*\d+(\.\d+)?\s*%/i),
    sgstRate: new RegExp(/\bsgst\s*\d+(\.\d+)?\s*%/i),
    igstRate: new RegExp(/\bigst\s*\d+(\.\d+)?\s*%/i),
    cessRate: new RegExp(/^(?!TAD\b).*?\bcess\s*\d+(\.\d+)?\s*%/i),
    vatRate: new RegExp(/^(?!TAD\b).*?\bvat\s*\d+(\.\d+)?\s*%/i),
    tadRate: new RegExp(/\btad\b.*?\d+(\.\d+)?\s*%/i),
    cgst: new RegExp(/cgst/i),
    sgst: new RegExp(/sgst/i),
    igst: new RegExp(/igst/i),
    cess: new RegExp(/cess/i),
    tad: new RegExp(/tad/i),
    excise: new RegExp(/excise/i),
    vat: new RegExp(/VAT/i),
    ifsc: new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/),
    withinIDFCBank: new RegExp(/^(IDFB|IDFC)0[A-Z0-9]{6}$/),
    ptDateFormat: new RegExp(/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/),
    ptUnExpectedDateFormatMMDDYYYY: new RegExp(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/),
    ptUnExpectedDateFormatDDMMYYYY: new RegExp(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/),
    ptManuFacturingOrExpiryDate: new RegExp(/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/)
  };
  defaultDebounceTime = 400;
  allowedMaxInvoiceCount = 10;
  allowedMaxInvoiceSize = 150 * 1024 * 1024;
  allowedMaxInvoicePageCount = 10;
  allowedMaxInvoicePageSize = 150 * 1024 * 1024;
  allowedAadharSize = 20 * 1024 * 1024; // 10,485,760 bytes
  invoicePerPage = 10;
  pageSizes = [10, 20, 30];
  invoiceListUpdateInterval = 10 * 1000;
  inprocessInvoiceUpdateInterval = 30 * 1000;
  homePath = ['/dashboard'];
  purchaseManagerPath = ['/purchase-manager'];
  leadAdminPath = ['/hyperpure-reports'];
  leadAdminModuleAccessUser = ['leadadmin@kharcha.com', 'yashbhavsar@leadadmin.com', 'chintantrivedi@leadadmin.com', 'niravvaghela@leadadmin.com', 'vedantpatel@leadadmin.com'];
  adminPath = ['/invoice'];
  allowedOrdersForLeadAdmin = ['Hyperpure Reports', 'DeliverIt Reports', 'PM Analytics', 'Hyperpure Deactivation', 'Invoice Summary', 'Buyer', 'User Management', 'Secondary Lead Admin', 'Supplier', 'Reports', 'Dormancy', 'Utilities', 'Merge Companies', 'Clear User Data'];

  /**
   * Get the default landing path based on user role
   * - LeadAdmin users: '/dashboard'
   * - Admin users: '/invoice'
   * - Other roles: '/purchase-manager'
   */
  getDefaultLandingPath(user: any): string[] {
    if (user?.isLeadAdmin) {
      return this.leadAdminPath;
    } else if (user?.isAdmin) {
      return this.adminPath;
    } else {
      return this.purchaseManagerPath;
    }
  }
  retryCount = 5;
  retryWaitMilliSeconds = 500;
  dateFormat: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' };
  minInvoiceForDashboard = 0;
  subscriptionPlaneExpired = 'The subscription plan of the selected company has expired.'
  timer = 30;
  minAsyncSearchCharacter = 3;
  maxProductSearchLimit = 10;
  minimumInvoiceDate = new Date('2020-01-01');
  invoiceDateFormat = 'YYYY-MM-DD';
  idleReviewTimeMS = 5 * 1000;
  NO_RESULT = 'no_results';
  NOT_FOUND = 'Not Found';
  PTTableFields = {
    quantity: 'quantity',
    rate: 'rate',
    nettotal: 'nettotal',
    subtotal: 'subTotal',
    discountamount: 'discountAmount',
    discountRate: 'discountRate',
    discount: 'discount',
    gst: 'gst',
    gstAmount: 'gstAmount',
    cgstAmount: 'cgstAmount',
    sgstAmount: 'sgstAmount',
    igstAmount: 'igstAmount',
    utgstAmount: 'utgstAmount',
    grandtotal: 'grandTotal',
    totalamount: 'totalAmount',
    gstRate: 'gstRate',
    cgstRate: 'cgstRate',
    sgstRate: 'sgstRate',
    igstRate: 'igstRate',
    utgstRate: 'utgstRate',
    taxableAmount: 'taxableAmount',
    nonTaxableAmount: 'nonTaxableAmount',
    cgst: 'cgst',
    sgst: 'sgst',
    igst: 'igst',
    roundOff: 'roundOff',
    cessamount: 'cessAmount',
    cgst2Point5Percent: 'cgst2point5percent',
    sgst2Point5Percent: 'sgst2point5percent',
    tad2Point5Percent: 'tad2point5percent',
    cgst1Point5Percent: 'cgst1point5percent',
    sgst1Point5Percent: 'sgst1point5percent',
    tad1Point5Percent: 'tad1point5percent',
    cgst3Percent: 'cgst3percent',
    sgst3Percent: 'sgst3percent',
    cgst6Percent: 'cgst6percent',
    sgst6Percent: 'sgst6percent',
    tad6Percent: 'tad6percent',
    cgst9Percent: 'cgst9percent',
    sgst9Percent: 'sgst9percent',
    tad9Percent: 'tad9percent',
    cgst14Percent: 'cgst14percent',
    sgst14Percent: 'sgst14percent',
    tad14Percent: 'tad14percent',
    igst3Percent: 'igst3percent',
    tad3Percent: 'tad3percent',
    igst5Percent: 'igst5percent',
    tad5Percent: 'tad5percent',
    igst6Percent: 'igst6percent',
    igst12Percent: 'igst12percent',
    tad12Percent: 'tad12percent',
    igst18Percent: 'igst18percent',
    tad18Percent: 'tad18percent',
    igst28Percent: 'igst28percent',
    tad28Percent: 'tad28percent',
    igst40Percent: 'igst40percent',
    tad40Percent: 'tad40Percent',
    cgst20Percent: 'cgst20percent',
    sgst20Percent: 'sgst20percent',
    tad20Percent: 'tad20percent',
    cess60Percent: 'cess60percent',
    tad60Percent: 'tad60percent',
    cess12Percent: 'cess12percent',
    cessTad12Percent: 'cesstad12percent',
    cess71Percent: 'cess71percent',
    tad71Percent: 'tad71percent',
    cess65Percent: 'cess65percent',
    tad65Percent: 'tad65percent',
    cess61Percent: 'cess61percent',
    tad61Percent: 'tad61percent',
    cess160Percent: 'cess160percent',
    tad160Percent: 'tad160percent',
    cess142Percent: 'cess142percent',
    tad142Percent: 'tad142percent',
    cess204Percent: 'cess204percent',
    tad204Percent: 'tad204percent',
    cess5Percent: 'cess5percent',
    cessTad5Percent: 'cesstad5percent',
    cess12Point5Percent: 'cess12Point5percent',
    tad12Point5Percent: 'tad12Point5percent',
    cess72Percent: 'cess72percent',
    tad72Percent: 'tad72percent',
    cessRate: 'cessRate',
    rateExclusiveTax: 'rateExclusive',
    vatRate: 'vatRate',
    vatAmount: 'vatAmount',
    vat31Percent: 'vat31percent',
    tadVAT31Percent: 'tadVAT31percent',
    vat22Point25Percent: 'vat22Point25percent',
    tadVAT22Point25Percent: 'tadVAT22Point25percent',
    vat19Point40Percent: 'vat19Point40percent',
    tadVAT19Point40Percent: 'tadVAT19Point40percent',
    vat16Point75Percent: 'vat16Point75percent',
    tadVAT16Point75Percent: 'tadVAT16Point75percent',
    vat21Point50Percent: 'vat21Point50percent',
    tadVAT21Point50Percent: 'tadVAT21Point50percent',
    vat22Percent: 'vat22percent',
    tadVAT22Percent: 'tadVAT22percent',
    vat117Point5Percent: 'vat117Point5percent',
    tadVAT117Point5Percent: 'tadVAT117Point5percent',
    vat13Point7Percent: 'vat13Point7percent',
    tadVAT13Point7Percent: 'tadVAT13Point7percent',
    vat14Point9Percent: 'vat14Point9percent',
    tadVAT14Point9Percent: 'tadVAT14Point9percent',
    vat25Percent: 'vat25percent',
    tadVAT25Percent: 'tadVAT25percent',
    vat21Percent: 'vat21percent',
    tadVAT21Percent: 'tadVAT21percent',
    vat29Point04Percent: 'vat29Point04percent',
    tadVAT29Point04Percent: 'tadVAT29Point04percent',
    vat17Point3Percent: 'vat17Point3percent',
    tadVAT17Point3Percent: 'tadVAT17Point3percent',
    vat13Percent: 'vat13percent',
    tadVAT13Percent: 'tadVAT13percent',
    vat11Percent: 'vat11percent',
    tadVAT11Percent: 'tadVAT11percent',
    vat35Point20Percent: 'vat35Point20percent',
    tadVAT35Point20Percent: 'tadVAT35Point20percent',
    vat27Percent: 'vat27percent',
    tadVAT27Percent: 'tadVAT27percent',
    vat28Percent: 'vat28percent',
    tadVAT28Percent: 'tadVAT28percent',
    exciseRate: 'exciseRate',
    vat: 'vat',
    excise: 'excise',
    cess: 'cess',
    unit: 'unit',
    liquorAmount: 'liquorAmount',
    tad: 'tad',
    tadVAT: 'tadVAT',
    tadCESS: 'tadCESS',
    otherCharges: 'otherCharges',
    narration: 'narration',
    expiryDate: 'expiryDate',
    manufacturingDate: 'manufacturingDate',
    petpoojaTag: 'petpoojaTag'
  }
  TTTableStrings: any = {
    subtotal: 'Sub Total',
    grandtotal: 'Grand Total',
    roundoff: 'Round Off',
    nettotal: 'Net Total',
    discountamount: 'Discount Amount',
    discountrate: 'Discount Rate',
    gstamount: 'GST Amount',
    cgstamount: 'CGST Amount',
    sgstamount: 'SGST Amount',
    igstamount: 'IGST Amount',
    utgstamount: 'UTGST Amount',
    totalamount: 'Total Amount',
    quantity: 'Quantity',
    rate: 'Rate',
    taxableamount: 'Taxable Amount',
    nontaxableamount: 'Non-Taxable Amount',
    cgst: 'cgst',
    sgst: 'sgst',
    igst: 'igst',
    cessamount: 'CESS Amount',
    gstrate: 'GST Rate',
    cgstrate: 'CGST Rate',
    sgstrate: 'SGST Rate',
    igstrate: 'IGST Rate',
    utgstrate: 'UTGST Rate',
    utgst: 'utgst',
    cgst1point5Percent: 'CGST 1.5%',
    sgst1point5Percent: 'SGST 1.5%',
    tad1point5Percent: 'TAD 1.5%',
    cgst2point5Percent: 'CGST 2.5%',
    sgst2point5Percent: 'SGST 2.5%',
    tad2point5Percent: 'TAD 2.5%',
    cgst3Percent: 'CGST 3%',
    sgst3Percent: 'SGST 3%',
    cgst6Percent: 'CGST 6%',
    sgst6Percent: 'SGST 6%',
    tad6Percent: 'TAD 6%',
    cgst9Percent: 'CGST 9%',
    sgst9Percent: 'SGST 9%',
    tad9Percent: 'TAD 9%',
    cgst14Percent: 'CGST 14%',
    sgst14Percent: 'SGST 14%',
    tad14Percent: 'TAD 14%',
    igst3Percent: 'IGST 3%',
    tad3Percent: 'TAD 3%',
    igst5Percent: 'IGST 5%',
    tad5Percent: 'TAD 5%',
    igst6Percent: 'IGST 6%',
    igst12Percent: 'IGST 12%',
    tad12Percent: 'TAD 12%',
    igst18Percent: 'IGST 18%',
    tad18Percent: 'TAD 18%',
    igst28Percent: 'IGST 28%',
    tad28Percent: 'TAD 28%',
    igst40Percent: 'IGST 40%',
    cgst20Percent: 'CGST 20%',
    sgst20Percent: 'SGST 20%',
    tad20Percent: 'TAD 20%',
    tad40Percent: 'TAD 40%',
    cess60Percent: 'CESS 60%',
    cess12Percent: 'CESS 12%',
    cess71Percent: 'CESS 71%',
    cess65Percent: 'CESS 65%',
    cess61Percent: 'CESS 61%',
    cess160Percent: 'CESS 160%',
    cess142Percent: 'CESS 142%',
    cess204Percent: 'CESS 204%',
    cess5Percent: 'CESS 5%',
    cess12point5Percent: 'CESS 12.5%',
    cess72Percent: 'CESS 72%',
    cessTad60Percent: 'TAD CESS 60%',
    cessTad12Percent: 'TAD CESS 12%',
    cessTad71Percent: 'TAD CESS 71%',
    cessTad65Percent: 'TAD CESS 65%',
    cessTad61Percent: 'TAD CESS 61%',
    cessTad160Percent: 'TAD CESS 160%',
    cessTad142Percent: 'TAD CESS 142%',
    cessTad204Percent: 'TAD CESS 204%',
    cessTad5Percent: 'TAD CESS 5%',
    cessTad12Point5Percent: 'TAD CESS 12.5%',
    cessTad72Percent: 'TAD CESS 72%',
    tadCESS: 'TAD CESS',
    tadVAT: 'TAD VAT',
    cessrate: 'CESS Rate',
    rateExclusiveTax: 'Rate Exclusive',
    vatrate: 'VAT Rate',
    vat31Percent: 'VAT 31%',
    tadVAT31Percent: 'TAD VAT 31%',
    vat22Point25Percent: 'VAT 22.25%',
    tadVAT22Point25Percent: 'TAD VAT 22.25%',
    vat19Point40Percent: 'VAT 19.40%',
    vat28Percent: 'VAT 28%',
    tadVAT19Point40Percent: 'TAD VAT 19.40%',
    tadVAT28Percent: 'TAD VAT 28%',
    vat16Point75Percent: 'VAT 16.75%',
    tadVAT16Point75Percent: 'TAD VAT 16.75%',
    vat21Point50Percent: 'VAT 21.50%',
    tadVAT21Point50Percent: 'TAD VAT 21.50%',
    vat22Percent: 'VAT 22%',
    tadVAT22Percent: 'TAD VAT 22%',
    vat117Point5Percent: 'VAT 117.5%',
    tadVAT117Point5Percent: 'TAD VAT 117.5%',
    vat13Point7Percent: 'VAT 13.7%',
    tadVAT13Point7Percent: 'TAD VAT 13.7%',
    vat14Point9Percent: 'VAT 14.9%',
    tadVAT14Point9Percent: 'TAD VAT 14.9%',
    vat25Percent: 'VAT 25%',
    tadVAT25Percent: 'TAD VAT 25%',
    vat21Percent: 'VAT 21%',
    tadVAT21Percent: 'TAD VAT 21%',
    vat29Point04Percent: 'VAT 29.04%',
    tadVAT29Point04Percent: 'TAD VAT 29.04%',
    vat17Point3Percent: 'VAT 17.3%',
    tadVAT17Point3Percent: 'TAD VAT 17.3%',
    vat13Percent: 'VAT 13%',
    tadVAT13Percent: 'TAD VAT 13%',
    vat11Percent: 'VAT 11%',
    tadVAT11Percent: 'TAD VAT 11%',
    vat35Point20Percent: 'VAT 35.20%',
    tadVAT35Point20Percent: 'TAD VAT 35.20%',
    vat27Percent: 'VAT 27%',
    tadVAT27Percent: 'TAD VAT 27%',
    liquorAmount: 'Liquor Amount',
    exciserate: 'Excise Rate',
    vat: 'VAT',
    excise: 'Excise',
    exciseAmount: 'Excise Amount',
    discount: 'discount',
    cess: 'Cess',
    description: 'description',
    vatamount: 'VAT Amount',
    hsn: 'HSN Code/SAC',
    tad: 'tad',
    narration: "Narration",
    unitOfMeasurement: "Unit of measurement",
    tdsApplicable: "TDS Applicable?",
    tcsApplicable: "TCS Applicable?",
    expiryDate: "Expiry Date",
    manufacturingDate: 'Manufacturing Date',
    tags: 'Petpooja Tag'
  }
  JSSFormula = {
    Product: 'PRODUCT',
    Division: '/',
    SUM: 'SUM'
  }
  JSSOtherCharges = [
    'Delivery Charges',
    'Shipping Charges',
    'Freight And Packing Charges',
    'Transportation Charges',
    'Insurance Charges',
    'Packing And Forwarding Charges',
    'Fuel Charges',
    'Packing Charges',
    'Labour Charges',
    'Courier Charges',
    'Freight Charges',
    'Other Charges',
    'Court Fees Stamp Charges',
    'Handling Charges'
  ];
  tax = ['gstAmount', 'cgstAmount', 'sgstAmount', 'igstAmount', 'cessAmount', 'vatAmount', 'exciseAmount'];
  jspTaxes = [{
    taxes: [{
      taxes: [{
        name: 'igstAmount',
        isPercentage: false
      }],
      alternativeTaxes: [{
        name: 'igstRate',
        isPercentage: true
      }]
    }],
    alternativeTaxes: [{
      taxes: [{
        taxes: [{
          taxes: [{
            name: 'cgstAmount',
            isPercentage: false
          }],
          alternativeTaxes: [{
            name: 'cgstRate',
            isPercentage: true
          }]
        }]
      }, {
        taxes: [{
          taxes: [{
            name: 'sgstAmount',
            isPercentage: false
          }],
          alternativeTaxes: [{
            name: 'sgstRate',
            isPercentage: true
          }]
        }]
      }],
      isAllMandatory: true,
      alternativeTaxes: [{
        taxes: [{
          name: 'gstAmount',
          isPercentage: false
        }],
        alternativeTaxes: [{
          name: 'gstRate',
          isPercentage: true
        }]
      }]
    }]
  }, {
    taxes: [{
      name: 'cessAmount',
      isPercentage: false
    }],
    alternativeTaxes: [{
      name: 'cessRate',
      isPercentage: true
    }]
  }, {
    taxes: [{
      name: 'exciseAmount',
      isPercentage: false
    }],
    alternativeTaxes: [{
      name: 'exciseRate',
      isPercentage: true
    }]
  }, {
    taxes: [{
      name: 'vatAmount',
      isPercentage: false
    }],
    alternativeTaxes: [{
      name: 'vatRate',
      isPercentage: true
    }]
  }];
  taxFields = ['GST Amount', 'CGST Amount', 'SGST Amount', 'IGST Amount', 'UTGST Amount', 'GST Rate', 'CGST Rate', 'SGST Rate', 'IGST Rate', 'UTGST Rate'];
  taxRates = ['GST Rate', 'CGST Rate', 'SGST Rate', 'IGST Rate', 'UTGST Rate', 'CESS Rate', 'VAT Rate'];
  rateOtherCharges = [
    'courierCharges',
    'deliveryCharges',
    'freightAndPackingCharges',
    'freightCharges',
    'fuelCharges',
    'insuranceCharges',
    'labourCharges',
    'otherCharges',
    'packingAndForwardingCharges',
    'packingCharges',
    'shippingCharges',
    'transportationCharges',
    'discount',
    'courtFeesStampCharges',
    'handlingCharges'
  ];
  tcsOtherCharges = [
    'courierCharges',
    'deliveryCharges',
    'discount',
    'freightAndPackingCharges',
    'freightCharges',
    'fuelCharges',
    'insuranceCharges',
    'labourCharges',
    'otherCharges',
    'packingAndForwardingCharges',
    'packingCharges',
    'shippingCharges',
    'transportationCharges',
    'courtFeesStampCharges',
    'handlingCharges'
  ];
  PURCHASE = 'purchase';
  EXPENSE = 'expense';
  JSSNetTotalField = { field: this.PTTableFields.nettotal, name: this.PTTableFields.nettotal };
  // jspreadsheet key for all domains
  JSpreadSheetLicense = 'ZWI1NmFjOWNiMDgyYmQxODU3OWZmNDBjMWY1MGFiZDZlZGM2MjY5NTI1ODNjZDJiYjg3ZDM0YmZlY2UzZWRjNGJkZDZlZWQ4MDJmMjAzZTRhOWNmYmE2NWM2MzQ5OTFlYTgyODRiNmQ0NDUyNGViMTQ2MDA0ODNhMjA5NzM4MDgsZXlKamJHbGxiblJKWkNJNklqRm1abVEyWWpGbE5tUTFOV000TkRBNVpUQmpNelJrTlRCbU16bGpNMlU0WVRKaU5UVXpaV1lpTENKdVlXMWxJam9pVG1GcGRHbHJJRk5vWVdnaUxDSmtZWFJsSWpveE9ERXpNVEF3TkRBd0xDSmtiMjFoYVc0aU9sc2lZWFJvWlc1aGFXNTJiMmxqWlM1d1pYUndiMjlxWVM1amIyMGlMQ0pwYm5admFXTmxMbkJsZEhCdmIycGhMbU52YlNJc0ltUmxiV1YwWlhKcGJuWnZhV05sTG5CbGRIQnZiMnBoTG1OdmJTSXNJbnBsZFhOcGJuWnZhV05sTG5CbGRIQnZiMnBoTG1OdmJTSXNJbkJoZVhKdmJHd3VjR1YwY0c5dmFtRXVZMjl0SWl3aWNIVnlZMmhoYzJVdWNHVjBjRzl2YW1FdVkyOXRJaXdpYzNSaFoybHVaM0JoZVhKdmJHd3VjR1YwY0c5dmFtRXVZMjl0SWl3aWJHOWpZV3hvYjNOMElsMHNJbkJzWVc0aU9pSXpNeUlzSW5OamIzQmxJanBiSW5ZM0lpd2lkamdpTENKMk9TSXNJbll4TUNJc0luWXhNU0lzSW5ZeE1pSXNJbVp2Y20xMWJHRWlMQ0ptYjNKdGN5SXNJbkpsYm1SbGNpSXNJbkJoY25ObGNpSXNJbWx0Y0c5eWRHVnlJaXdpYzJWaGNtTm9JaXdpWTI5dGJXVnVkSE1pTENKMllXeHBaR0YwYVc5dWN5SXNJbU5vWVhKMGN5SmRmUT09'
  otherChargesRates = [0, 3, 5, 6, 12, 18, 28, 40];
  otherChargesHalfRates = [0, 1.5, 2.5, 3, 6, 9, 14, 20];
  cessRates = [0, 60, 12, 71, 65, 61, 160, 142, 204, 5, 12.5, 72];
  vatRates = [11, 13, 13.7, 14.9, 16.75, 17.3, 19.40, 21, 21.50, 22, 22.25, 25, 27, 28, 29.04, 31, 35.20, 117.5];
  GSTRelatedColumns = ['GST Rate', 'CGST Rate', 'GST Amount', 'SGST Rate', 'CGST Amount', 'SGST Amount'];
  IGSTRelatedColumns = ['IGST Rate', 'IGST Amount'];
  GSTRates = {
    3: {
      fieldIGST: this.PTTableFields.igst3Percent,
      nameIGST: this.TTTableStrings.igst3Percent,
      fieldCGST: this.PTTableFields.cgst1Point5Percent,
      nameCGST: this.TTTableStrings.cgst1point5Percent,
      fieldSGST: this.PTTableFields.sgst1Point5Percent,
      nameSGST: this.TTTableStrings.sgst1point5Percent,
      fieldTAD: this.PTTableFields.tad1Point5Percent,
      nameTAD: this.TTTableStrings.tad1point5Percent,
      fieldIGSTTAD: this.PTTableFields.tad3Percent,
      nameIGSTTAD: this.TTTableStrings.tad3Percent
    },
    5: {
      fieldIGST: this.PTTableFields.igst5Percent,
      nameIGST: this.TTTableStrings.igst5Percent,
      fieldCGST: this.PTTableFields.cgst2Point5Percent,
      nameCGST: this.TTTableStrings.cgst2point5Percent,
      fieldSGST: this.PTTableFields.sgst2Point5Percent,
      nameSGST: this.TTTableStrings.sgst2point5Percent,
      fieldTAD: this.PTTableFields.tad2Point5Percent,
      nameTAD: this.TTTableStrings.tad2point5Percent,
      fieldIGSTTAD: this.PTTableFields.tad5Percent,
      nameIGSTTAD: this.TTTableStrings.tad5Percent
    },
    6: {
      fieldIGST: this.PTTableFields.igst6Percent,
      nameIGST: this.TTTableStrings.igst6Percent,
      fieldCGST: this.PTTableFields.cgst3Percent,
      nameCGST: this.TTTableStrings.cgst3Percent,
      fieldSGST: this.PTTableFields.sgst3Percent,
      nameSGST: this.TTTableStrings.sgst3Percent,
      fieldTAD: this.PTTableFields.tad3Percent,
      nameTAD: this.TTTableStrings.tad3Percent,
      fieldIGSTTAD: this.PTTableFields.tad6Percent,
      nameIGSTTAD: this.TTTableStrings.tad6Percent
    },
    12: {
      fieldIGST: this.PTTableFields.igst12Percent,
      nameIGST: this.TTTableStrings.igst12Percent,
      fieldCGST: this.PTTableFields.cgst6Percent,
      nameCGST: this.TTTableStrings.cgst6Percent,
      fieldSGST: this.PTTableFields.sgst6Percent,
      nameSGST: this.TTTableStrings.sgst6Percent,
      fieldTAD: this.PTTableFields.tad6Percent,
      nameTAD: this.TTTableStrings.tad6Percent,
      fieldIGSTTAD: this.PTTableFields.tad12Percent,
      nameIGSTTAD: this.TTTableStrings.tad12Percent
    },
    18: {
      fieldIGST: this.PTTableFields.igst18Percent,
      nameIGST: this.TTTableStrings.igst18Percent,
      fieldCGST: this.PTTableFields.cgst9Percent,
      nameCGST: this.TTTableStrings.cgst9Percent,
      fieldSGST: this.PTTableFields.sgst9Percent,
      nameSGST: this.TTTableStrings.sgst9Percent,
      fieldTAD: this.PTTableFields.tad9Percent,
      nameTAD: this.TTTableStrings.tad9Percent,
      fieldIGSTTAD: this.PTTableFields.tad18Percent,
      nameIGSTTAD: this.TTTableStrings.tad18Percent
    },
    28: {
      fieldIGST: this.PTTableFields.igst28Percent,
      nameIGST: this.TTTableStrings.igst28Percent,
      fieldCGST: this.PTTableFields.cgst14Percent,
      nameCGST: this.TTTableStrings.cgst14Percent,
      fieldSGST: this.PTTableFields.sgst14Percent,
      nameSGST: this.TTTableStrings.sgst14Percent,
      fieldTAD: this.PTTableFields.tad14Percent,
      nameTAD: this.TTTableStrings.tad14Percent,
      fieldIGSTTAD: this.PTTableFields.tad28Percent,
      nameIGSTTAD: this.TTTableStrings.tad28Percent
    },
    40: {
      fieldIGST: this.PTTableFields.igst40Percent,
      nameIGST: this.TTTableStrings.igst40Percent,
      fieldCGST: this.PTTableFields.cgst20Percent,
      nameCGST: this.TTTableStrings.cgst20Percent,
      fieldSGST: this.PTTableFields.sgst20Percent,
      nameSGST: this.TTTableStrings.sgst20Percent,
      fieldTAD: this.PTTableFields.tad20Percent,
      nameTAD: this.TTTableStrings.tad20Percent,
      fieldIGSTTAD: this.PTTableFields.tad40Percent,
      nameIGSTTAD: this.TTTableStrings.tad40Percent
    }
  }
  CESSRates = {
    60: {
      fieldCESS: this.PTTableFields.cess60Percent,
      nameCESS: this.TTTableStrings.cess60Percent,
      fieldTAD: this.PTTableFields.tad60Percent,
      nameTAD: this.TTTableStrings.cessTad60Percent,
    },
    12: {
      fieldCESS: this.PTTableFields.cess12Percent,
      nameCESS: this.TTTableStrings.cess12Percent,
      fieldTAD: this.PTTableFields.cessTad12Percent,
      nameTAD: this.TTTableStrings.cessTad12Percent,
    },
    71: {
      fieldCESS: this.PTTableFields.cess71Percent,
      nameCESS: this.TTTableStrings.cess71Percent,
      fieldTAD: this.PTTableFields.tad71Percent,
      nameTAD: this.TTTableStrings.cessTad71Percent,
    },
    65: {
      fieldCESS: this.PTTableFields.cess65Percent,
      nameCESS: this.TTTableStrings.cess65Percent,
      fieldTAD: this.PTTableFields.tad65Percent,
      nameTAD: this.TTTableStrings.cessTad65Percent,
    },
    61: {
      fieldCESS: this.PTTableFields.cess61Percent,
      nameCESS: this.TTTableStrings.cess61Percent,
      fieldTAD: this.PTTableFields.tad61Percent,
      nameTAD: this.TTTableStrings.cessTad61Percent,
    },
    160: {
      fieldCESS: this.PTTableFields.cess160Percent,
      nameCESS: this.TTTableStrings.cess160Percent,
      fieldTAD: this.PTTableFields.tad160Percent,
      nameTAD: this.TTTableStrings.cessTad160Percent,
    },
    142: {
      fieldCESS: this.PTTableFields.cess142Percent,
      nameCESS: this.TTTableStrings.cess142Percent,
      fieldTAD: this.PTTableFields.tad142Percent,
      nameTAD: this.TTTableStrings.cessTad142Percent,
    },
    204: {
      fieldCESS: this.PTTableFields.cess204Percent,
      nameCESS: this.TTTableStrings.cess204Percent,
      fieldTAD: this.PTTableFields.tad204Percent,
      nameTAD: this.TTTableStrings.cessTad204Percent,
    },
    5: {
      fieldCESS: this.PTTableFields.cess5Percent,
      nameCESS: this.TTTableStrings.cess5Percent,
      fieldTAD: this.PTTableFields.tad5Percent,
      nameTAD: this.TTTableStrings.cessTad5Percent,
    },
    12.5: {
      fieldCESS: this.PTTableFields.cess12Point5Percent,
      nameCESS: this.TTTableStrings.cess12point5Percent,
      fieldTAD: this.PTTableFields.tad12Point5Percent,
      nameTAD: this.TTTableStrings.cessTad12Point5Percent,
    },
    72: {
      fieldCESS: this.PTTableFields.cess72Percent,
      nameCESS: this.TTTableStrings.cess72Percent,
      fieldTAD: this.PTTableFields.tad72Percent,
      nameTAD: this.TTTableStrings.cessTad72Percent,
    },
  }
  VATRates = {
    11: {
      fieldVAT: this.PTTableFields.vat11Percent,
      nameVAT: this.TTTableStrings.vat11Percent,
      fieldTAD: this.PTTableFields.tadVAT11Percent,
      nameTAD: this.TTTableStrings.tadVAT11Percent
    },

    13: {
      fieldVAT: this.PTTableFields.vat13Percent,
      nameVAT: this.TTTableStrings.vat13Percent,
      fieldTAD: this.PTTableFields.tadVAT13Percent,
      nameTAD: this.TTTableStrings.tadVAT13Percent
    },

    13.7: {
      fieldVAT: this.PTTableFields.vat13Point7Percent,
      nameVAT: this.TTTableStrings.vat13Point7Percent,
      fieldTAD: this.PTTableFields.tadVAT13Point7Percent,
      nameTAD: this.TTTableStrings.tadVAT13Point7Percent
    },

    14.9: {
      fieldVAT: this.PTTableFields.vat14Point9Percent,
      nameVAT: this.TTTableStrings.vat14Point9Percent,
      fieldTAD: this.PTTableFields.tadVAT14Point9Percent,
      nameTAD: this.TTTableStrings.tadVAT14Point9Percent
    },

    16.75: {
      fieldVAT: this.PTTableFields.vat16Point75Percent,
      nameVAT: this.TTTableStrings.vat16Point75Percent,
      fieldTAD: this.PTTableFields.tadVAT16Point75Percent,
      nameTAD: this.TTTableStrings.tadVAT16Point75Percent
    },

    17.3: {
      fieldVAT: this.PTTableFields.vat17Point3Percent,
      nameVAT: this.TTTableStrings.vat17Point3Percent,
      fieldTAD: this.PTTableFields.tadVAT17Point3Percent,
      nameTAD: this.TTTableStrings.tadVAT17Point3Percent
    },

    19.40: {
      fieldVAT: this.PTTableFields.vat19Point40Percent,
      nameVAT: this.TTTableStrings.vat19Point40Percent,
      fieldTAD: this.PTTableFields.tadVAT19Point40Percent,
      nameTAD: this.TTTableStrings.tadVAT19Point40Percent
    },

    21: {
      fieldVAT: this.PTTableFields.vat21Percent,
      nameVAT: this.TTTableStrings.vat21Percent,
      fieldTAD: this.PTTableFields.tadVAT21Percent,
      nameTAD: this.TTTableStrings.tadVAT21Percent
    },
    21.50: {
      fieldVAT: this.PTTableFields.vat21Point50Percent,
      nameVAT: this.TTTableStrings.vat21Point50Percent,
      fieldTAD: this.PTTableFields.tadVAT21Point50Percent,
      nameTAD: this.TTTableStrings.tadVAT21Point50Percent
    },
    22: {
      fieldVAT: this.PTTableFields.vat22Percent,
      nameVAT: this.TTTableStrings.vat22Percent,
      fieldTAD: this.PTTableFields.tadVAT22Percent,
      nameTAD: this.TTTableStrings.tadVAT22Percent
    },
    22.25: {
      fieldVAT: this.PTTableFields.vat22Point25Percent,
      nameVAT: this.TTTableStrings.vat22Point25Percent,
      fieldTAD: this.PTTableFields.tadVAT22Point25Percent,
      nameTAD: this.TTTableStrings.tadVAT22Point25Percent
    },

    25: {
      fieldVAT: this.PTTableFields.vat25Percent,
      nameVAT: this.TTTableStrings.vat25Percent,
      fieldTAD: this.PTTableFields.tadVAT25Percent,
      nameTAD: this.TTTableStrings.tadVAT25Percent
    },

    27: {
      fieldVAT: this.PTTableFields.vat27Percent,
      nameVAT: this.TTTableStrings.vat27Percent,
      fieldTAD: this.PTTableFields.tadVAT27Percent,
      nameTAD: this.TTTableStrings.tadVAT27Percent
    },

    28: {
      fieldVAT: this.PTTableFields.vat28Percent,
      nameVAT: this.TTTableStrings.vat28Percent,
      fieldTAD: this.PTTableFields.tadVAT28Percent,
      nameTAD: this.TTTableStrings.tadVAT28Percent
    },

    29.04: {
      fieldVAT: this.PTTableFields.vat29Point04Percent,
      nameVAT: this.TTTableStrings.vat29Point04Percent,
      fieldTAD: this.PTTableFields.tadVAT29Point04Percent,
      nameTAD: this.TTTableStrings.tadVAT29Point04Percent
    },

    31: {
      fieldVAT: this.PTTableFields.vat31Percent,
      nameVAT: this.TTTableStrings.vat31Percent,
      fieldTAD: this.PTTableFields.tadVAT31Percent,
      nameTAD: this.TTTableStrings.tadVAT31Percent
    },

    35.20: {
      fieldVAT: this.PTTableFields.vat35Point20Percent,
      nameVAT: this.TTTableStrings.vat35Point20Percent,
      fieldTAD: this.PTTableFields.tadVAT35Point20Percent,
      nameTAD: this.TTTableStrings.tadVAT35Point20Percent
    },

    117.5: {
      fieldVAT: this.PTTableFields.vat117Point5Percent,
      nameVAT: this.TTTableStrings.vat117Point5Percent,
      fieldTAD: this.PTTableFields.tadVAT117Point5Percent,
      nameTAD: this.TTTableStrings.tadVAT117Point5Percent
    }
  };


  ReviewPageHideHTMLTabDate = new Date('September 25, 2024 23:59:59');
  GOOGLE_RECAPTCHA_SITEKEY = '6LcKp1AqAAAAAAs-QMiwvjcj9y3STpmgF2DSUUdO';
  PM_DEMO_RECAPTCHA_SITEKEY = '6LedT6EtAAAAADMm6FL44Qt8LPs2O64ZaHt2QH9w';
  bankStatementFileTypes = [
    'application/pdf',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ];
  maxBankStatementFileCount = 1;
  maxBankStatementFileSize = 10 * 1024 * 1024;
  billReceivableFileTypes = [
    'application/pdf',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ];
  maxBillReceivableFileCount = 1;
  maxBillReceivableFileSize = 10 * 1024 * 1024;
  userAccessList = [
    {
      name: "Dashboard",
      url: '/dashboard',
      regex: new RegExp('^/dashboard$')
    },
    {
      name: "Upload Invoice",
      url: '/invoice/upload',
      regex: new RegExp('^/invoice/upload$')
    },
    {
      name: "Invoice Listing",
      url: '/invoice',
      regex: new RegExp('^/invoice$')
    },
    {
      name: "Invoice Review",
      url: '/invoice/{id}',
      regex: new RegExp('^/invoice/[a-f0-9]{24}$')
    },
    {
      name: "Tag Management",
      url: '/tag',
      regex: new RegExp('^/tag$')
    },
    {
      name: "Payments",
      url: '/payments',
      regex: new RegExp('^/payments$')
    },
    {
      name: "Payments",
      url: '/banking/introduction',
      regex: new RegExp('^/banking/introduction$')
    },
    {
      name: "Payments",
      url: '/banking/account-details',
      regex: new RegExp('^/banking/account-details$')
    },
    {
      name: "Payments",
      url: '/banking/beneficiary-list',
      regex: new RegExp('^/banking/beneficiary-list$')
    },
    {
      name: "Payments",
      url: '/payments/seller-list',
      regex: new RegExp('^/payments/seller-list$')
    },
    // {
    //   name: "Payments",
    //   url: '/banking/kyc-verify',
    //   regex: new RegExp('^/banking/kyc-verify$')
    // },
    {
      name: "Reports",
      url: '/report',
      regex: new RegExp('^/report$')
    },
    {
      name: "Petty Expense",
      url: '/petty-expense',
      regex: new RegExp('^/petty-expense$')
    },
    {
      name: "Entity Management",
      url: '/entity',
      regex: new RegExp('^/entity$')
    },
    {
      name: "User Management",
      url: '/user-management',
      regex: new RegExp('^/user-management$')
    },
    {
      name: "Petpooja Invoice",
      url: '/push-to-retail-pos',
      regex: new RegExp('^/push-to-retail-pos$')
    },
    // {
    //   name: "Push to Petpooja",
    //   url: '/push-to-petpooja',
    //   regex: new RegExp('^/push-to-petpooja$')
    // },
    {
      name: "Petpooja POS",
      url: '/push-to-petpooja',
      regex: new RegExp('^/push-to-petpooja$')
    },
    {
      name: "Petpooja POS",
      url: '/push-to-petpooja/manage-poss-tags',
      regex: new RegExp('^/push-to-petpooja/manage-poss-tags$')
    },
    {
      name: "Push to Petpooja",
      url: '/push-to-retail-pos',
      regex: new RegExp('^/push-to-retail-pos$')
    },
    {
      name: "Push to Petpooja",
      url: '/push-to-retail-pos/manage-invoice-tags',
      regex: new RegExp('^/push-to-retail-pos/manage-invoice-tags$')
    },
    {
      name: "Push to Tally",
      url: '/push-to-tally',
      regex: new RegExp('^/push-to-tally$')
    },
    {
      name: "Push to Tally",
      url: '/tally-config',
      regex: new RegExp('^/tally-config$')
    },
    {
      name: "Voucher",
      url: '/voucher',
      regex: new RegExp('^/voucher$')
    },
    {
      name: "Banking",
      url: '/banking',
      regex: new RegExp('^/banking$')
    },
    {
      name: "Integrations",
      url: '/integrations',
      regex: new RegExp('^/integrations$')
    },
    {
      name: "Integrations",
      url: '/integrations/integrations',
      regex: new RegExp('^/integrations/integrations$')
    },
    {
      name: "Checkout",
      url: '/purchase-manager/hyperpure-cart',
      regex: new RegExp('^/purchase-manager/hyperpure-cart')
    },
    {
      name: "Orders",
      url: '/purchase-manager/orders',
      regex: new RegExp('^/purchase-manager/orders')
    },
    {
      name: "Search",
      url: '/purchase-manager',
      regex: new RegExp('^/purchase-manager(?:/(?:price-discovery|suppliers))?(?:\\?|$)')
    }
  ];

  USER_ACCESS = {
    DASHBAORD: 'Dashboard',
    UPLOAD_INVOICE: 'Upload Invoice',
    INVOICE_LISTING: 'Invoice Listing',
    INVOICE_REVIEW: 'Invoice Review',
    TAG_MANAGEMENT: 'Tag Management',
    PAYMENTS: 'Payments',
    REPORTS: 'Reports',
    PATTY_EXPENSE: 'Petty Expense',
    VOUCHER: 'Voucher',
    BANKING: 'Banking',
    PUSH_TO_PETPOOJA: 'Push to Petpooja',
    PETPOOJA_INVOICE: 'Petpooja Invoice',
    PETPOOJA_POS: 'Petpooja POS',
    USER_MANAGEMENT: 'User Management',
    COMPANY_MANAGEMENT: 'Company Management',
    ENTITY_MANAGEMENT: 'Entity Management',
    PUSH_TO_TALLY: 'Push to Tally',
    PURCHASE_MANAGER: 'Purchase Manager',
    SEARCH: 'Search',
    ORDERS: 'Orders',
    CHECKOUT: 'Checkout',
    INTEGRATIONS: 'Integrations',
    UNKNOWN: 'Unknown',
  };

  KYC_STATUSES = {
    APPROVED: 'Approved',
    PENDING: 'Pending',
    FAILED: 'Failed',
    INPROGRESS: 'In Progress'
  };

  INDIAMOBILEINITIAL = "91";

  firmtypeListWithValue = [
    { id: 1, name: 'Proprietorship (Self employed)', value: 'proprietorship' },
    { id: 2, name: 'Private Limited', value: 'privateLimited' },
    { id: 3, name: 'Partnership Firm', value: 'partnershipFirm' },
    { id: 4, name: 'LLP firm', value: 'llpFirm' },
    { id: 5, name: 'Alcohol / Liquor / BAR / Wine Shops', value: 'aLBW' },
    { id: 6, name: 'Public Limited', value: 'publicLimited' },
    { id: 7, name: 'HUF', value: 'hUF' },
    { id: 8, name: 'Society Trust', value: 'societyTrust' },
  ];

  KYC_DOCUMENT_TYPES = {
    AADHAR_CARD: 'Adhar Card',
    DIRECTOR_DOCUMENT: 'Director Document',
    CANCELLED_CHEQUE: 'Cancelled Cheque'
  }

  PAYMENT_OPTIONS = {
    CASH: 'Cash',
    IDFC: 'IDFC',
    PETTY_CASH: 'Petty Cash'
  }

  PAYMENT_TYPE = {
    ADVANCE: 'Advance',
    ON_ACCOUNT: 'onAccount',
    INVOICE_SPECIFIC: 'Invoice Specific',
  }

  requiredPTFields = [
    "Description",
    "Quantity",
    "Rate",
    "Unit of measurement"
  ];

  calculatedColumnColor = '#F0F0F0';
  requiredCellBorderColor = '1px solid #f28a8a';
  totalTableRowCount = 4;
  DRAFT_REASONS = [
    { id: "1", name: "Company/Supplier Name is missing." },
    { id: "2", name: "Invoice Date is not provided." },
    { id: "3", name: "Mandatory fields are incomplete." },
    { id: "4", name: "Clarification required from client." },
    { id: "5", name: "Temporarily saving as draft." }
  ];

  validInvoiceTypes = ["image/jpeg", "image/png", "application/pdf"];
  beneficiariesValidationColor = '#FFDDDD';

  errorMessages = {
    DISCOUNT_CAN_NOT_BE_GREATER_THAN_NET_TOTAL: 'Discount cannot be greater than Net Total. Please enter a valid amount.',
    REMOVE_GST_CGST_SGST_TO_ADD_IGST: 'Please remove GST/CGST/SGST columns to add IGST.',
    REMOVE_IGST_TO_ADD_GST_CGST_SGST: 'Please remove IGST column to add GST/CGST/SGST.',
    ENTER_VALID_RATE: 'Please enter valid Rate',
    DESCRIPTION_MUST_HAVE_ONE_CHARACTER: 'Description must include at least one letter or number.',
    BLANK_COLUMN_EXISTS: 'Blank column already exists!',
    CAN_NOT_DELETE_MANDATORY_COLUMN: 'Cannot delete mandatory column(s)',
    DELETE_TAX_RATE_BEFORE_TAX_AMOUNT: 'Please delete the Tax Rate column first before deleting the Tax Amount column.',
    ENTER_VALID_INFO: 'Please enter valid information.',
    CAN_NOT_DELETE_HEADING: 'You cannot delete heading',
    COLUMN_EXISTS: 'Column already exists!',
    NO_INVOICES_ON_SELECTED_DATE: 'No invoices found on selected date',
    SELECT_COMPANY_TO_LINK_WITH_CREDIT_NOTE: 'Please select company to link Invoices with Credit Note',
    ENTER_VALID_INVOICE_NUMBER: 'Please enter a valid Invoice number.',
    ROWS_FROM_MULTIPLE_PAGES_CANNOT_BE_DELETED_TOGETHER: 'Rows from multiple pages cannot be deleted together. Please delete rows page by page.',
    CANNOT_DELETE_TAGS_COLUMN: 'Cannot delete Petpooja Tag column',
    CANNOT_ADD_PETPOOJA_TAG_COLUMN: 'Push to petpooja is not activated for selected entity',
  }

  successMessages = {
    INVOICE_REVIEWED: 'The invoice reviewed successfully!',
    NOT_A_DUPLICATE_INVOICE: 'This is not a duplicate invoice',
    INVOICE_REJECTED: 'The invoice rejected successfully!',
  }

  singleSelectModules = ['/invoice/upload', '/petty-expense', '/push-to-tally', '/tally-config', '/push-to-petpooja', '/push-to-retail-pos',
    '/push-to-retail-pos/manage-invoice-tags', '/push-to-petpooja/manage-poss-tags', '/integrations', '/purchase-manager', '/purchase-manager/orders', '/purchase-manager/suppliers', '/purchase-manager/analytics', '/purchase-manager', '/hyperpure/orders'];
  multiSelectModules = ['/dashboard', '/invoice', '/report', '/tag', '/payments/seller-list', '/payments'];
  singleSelectCompanyModules = ['/banking'];

  invoiceUploadLimitHitMessage = 'You\'ve hit the 10-invoice limit! Upgrade now to upload without limits and unlock all features'

  exploreProductModules = {
    Integrations: 'Integrations',
    Banking: 'Banking',
    Reports: 'Reports',
    CreateUsers: 'CreateUsers',
    CreateCompany: 'CreateCompany'
  }

  settingSidebarMenus = ['/profile', '/company-management', '/entity', '/user-management', '/voucher', '/petty-expense/category-management'];

  sidebarSections = [
    {
      name: '',
      menus: [{
        name: 'Dashboard',
        svg: icons.dashboard,
        path: '/dashboard',
        roles: ['owner', 'leadAdmin'],
        requiresSecondaryOwnerAccess: true
      },
      {
        name: 'Purchase Manager',
        svg: icons.purchaseManagerIcon,
        roles: ['owner', 'admin', 'leadAdmin', 'manager'],
        requiresSecondaryOwnerAccess: true,
        requiresEnablePurchase: true,
        subMenus: [{
          name: 'Purchase Manager',
          svg: icons.purchaseManagerIcon,
          path: '/purchase-manager',
          roles: ['owner', 'admin', 'leadAdmin', 'manager'],
          requiresSecondaryOwnerAccess: true
        },
        {
          name: 'Orders',
          svg: icons.invoice,
          path: '/purchase-manager/orders',
          roles: ['owner', 'admin', 'leadAdmin', 'manager'],
          requiresSecondaryOwnerAccess: true
        },
        {
          name: 'Suppliers',
          svg: icons.supplier,
          path: '/purchase-manager/suppliers',
          roles: ['owner', 'admin', 'leadAdmin', 'manager'],
          requiresSecondaryOwnerAccess: true
        },
        {
          name: 'Analytics',
          key: 'pm_analytics',
          svg: icons.report,
          path: '/purchase-manager/analytics',
          // Accessible only to Lead Admin users
          roles: ['leadAdmin'],
          requiresSecondaryOwnerAccess: true
        }]
      },
      {
        name: 'Invoice',
        svg: icons.invoice,
        path: '/invoice',
        roles: ['owner', 'admin'],
        requiresSecondaryOwnerAccess: true
      },
      {
        name: 'Petty Expense',
        svg: icons.pettyExpense,
        path: '/petty-expense',
        roles: ['owner'],
        requiresSecondaryOwnerAccess: true
      },
      {
        name: 'Upload Invoice',
        svg: icons.invoice,
        path: '/invoice/upload',
        roles: ['admin'],
        requiresAdminUploadAccess: true
      },
      {
        name: 'Payment',
        svg: icons.payment,
        path: '/payments',
        roles: ['owner'],
        requiresSecondaryOwnerAccess: true
      },
      // {
      //   name: 'Banking',
      //   svg: icons.banking,
      //   roles: ['owner'],
      //   path: '/banking/account-details',
      //   requiresSecondaryOwnerAccess: true,
      //   // requiresPaid: true, // for paid users only
      //   subMenus: [{
      //     name: 'Account',
      //     svg: icons.account,
      //     path: '/banking/account-details',
      //     roles: ['owner'],
      //     // requiresPaid: true, // for paid users only
      //     requiresSecondaryOwnerAccess: true
      //   },
      //   {
      //     name: 'Payment',
      //     svg: icons.payment,
      //     path: '/payments',
      //     roles: ['owner'],
      //     // requiresPaid: true, // for paid users only
      //     requiresSecondaryOwnerAccess: true
      //   },
      //   {
      //     name: 'Beneficiary',
      //     svg: icons.beneficiary,
      //     path: '/banking/beneficiary-list',
      //     roles: ['owner'],
      //     featureFlag: 'showBeneficiary'
      //     // requiresPaid: true, // for paid users only
      //   }]
      // },
      // {
      //   name: 'Dashboard Tags',
      //   svg: icons.dashboardTags,
      //   path: '/tag',
      //   roles: ['owner', 'admin'],
      //   requiresPaid: true, // for paid users only
      //   requiresSecondaryOwnerAccess: true,
      // },

      {
        name: 'Payments',
        svg: icons.payment,
        path: '/payments',
        roles: ['admin'],
        requiresSecondaryOwnerAccess: true
      },
      {
        name: 'Reports',
        svg: icons.report,
        path: '/report',
        // 'leadAdmin' role removed to hide from lead admin left menu
        roles: ['owner'],
        requiresLeadAdminModuleAccess: true,
        requiresSecondaryOwnerAccess: true
      },
      {
        name: 'Integrations',
        svg: icons.integrationsIcon,
        path: '/integrations',
        roles: ['owner', 'manager']
      },
      ]
    },
    {
      name: '',
      menus: [
        //   {
        //   name: 'Report',
        //   key: 'reports',
        //   svg: icons.report,
        //   path: '/report',
        //   roles: ['owner', 'admin', 'leadAdmin'],
        //   requiresLeadAdminModuleAccess: true,
        //   requiresSecondaryOwnerAccess: true,
        //   requiresAdminViewAccess: true
        // },
        {
          name: 'Invoice Summary',
          key: 'invoice_summary',
          svg: icons.iSummary,
          path: '/invoice-review-summary',
          roles: ['leadAdmin'],
          requiresLeadAdminModuleAccess: true
        },
        {
          name: 'Buyer',
          key: 'buyer',
          svg: icons.buyer,
          path: '/buyer',
          roles: ['leadAdmin'],
          requiresLeadAdminModuleAccess: true
        },
        {
          name: 'Hyperpure Reports',
          key: 'hyperpure_reports',
          svg: icons.report,
          path: '/hyperpure-reports',
          roles: ['leadAdmin'],
          requiresLeadAdminModuleAccess: true
        },
        {
          name: 'DeliverIt Reports',
          key: 'deliverit_order',
          svg: icons.report,
          path: '/deliverit-reports',
          roles: ['leadAdmin'],
          requiresLeadAdminModuleAccess: true
        },
        {
          name: 'DeliverIt Reports',
          svg: icons.report,
          path: '/deliverit-reports',
          roles: ['leadAdmin'],
          requiresLeadAdminModuleAccess: true
        },
        {
          name: 'PM Analytics',
          key: 'pm_analytics',
          svg: icons.report,
          path: '/purchase-manager/analytics',
          roles: ['leadAdmin'],
          requiresLeadAdminModuleAccess: true
        },
        {
          name: 'User Management',
          key: 'user_management',
          svg: icons.users,
          path: '/lead-admin-user-management',
          roles: ['leadAdmin'],
          requiresLeadAdminModuleAccess: true

        },
        {
          name: 'Secondary Lead Admin',
          key: 'child_lead_admin_management',
          svg: icons.users,
          path: '/child-lead-admin-management',
          roles: ['leadAdmin'],
          requiresLeadAdminModuleAccess: true

        },
        {
          name: 'Hyperpure Deactivation',
          key: 'hyperpure_deactivation',
          svg: icons.supplier,
          path: '/hyperpure-deactivation',
          roles: ['leadAdmin'],
          requiresLeadAdminModuleAccess: true
        },
        {
          name: 'Dormancy',
          key: 'dormancy',
          svg: icons.buyer,
          path: '/dormancy',
          roles: ['leadAdmin'],
          requiresLeadAdminModuleAccess: true
        },
        {
          name: 'Utilities',
          svg: icons.report,
          roles: ['leadAdmin'],
          requiresLeadAdminModuleAccess: true,
          subMenus: [
            {
              name: 'Invoice Re-upload',
              key: 'invoice_reupload_utility',
              path: '/utilities/invoice-reupload',
              roles: ['leadAdmin'],
              requiresLeadAdminModuleAccess: true
            },
            {
              name: 'Invoice OCR',
              key: 'invoice_ocr_utility',
              path: '/utilities/invoice-ocr',
              roles: ['leadAdmin'],
              requiresLeadAdminModuleAccess: true
            },
            {
              name: 'Merge Companies',
              key: 'merge_companies_utility',
              path: '/utilities/merge-companies',
              roles: ['leadAdmin'],
              requiresLeadAdminModuleAccess: true
            },
            {
              name: 'Clear User Data',
              key: 'clear_user_data_utility',
              path: '/utilities/clear-user-data',
              roles: ['leadAdmin'],
              requiresLeadAdminModuleAccess: true
            },
            {
              name: 'Invoice OCR',
              key: 'invoice_ocr_utility',
              path: '/utilities/invoice-ocr',
              roles: ['leadAdmin'],
              requiresLeadAdminModuleAccess: true
            },
            {
              name: 'Failed Invoices',
              key: 'failed_invoices',
              path: '/utilities/failed-invoices',
              roles: ['leadAdmin'],
              requiresLeadAdminModuleAccess: true
            }
          ]
        },
        // Uncomment to enable Supplier
        // {
        //   name: 'Supplier',
        //   key: 'supplier',
        //   svg: icons.supplier,
        //   path: '/supplier',
        //   roles: ['leadAdmin'],
        //   requiresLeadAdminModuleAccess: true
        // },
        {
          name: 'KYC Details',
          svg: icons.supplier,
          path: '/kyc-details',
          roles: ['leadAdmin'],
        },
        {
          name: 'Account Dashboard',
          svg: icons.account,
          path: '/account-dashboard',
          roles: ['leadAdmin'],
        },
        // {
        //   name: 'Admin Account',
        //   svg: icons.supplier,
        //   path: '/admin-account',
        //   roles: ['leadAdmin'],
        // },
      ]
    }
  ];

  innerSidebarSections = [
    {
      name: '',
      menus: [{
        name: 'Settings',
        svg: icons.setting,
        roles: ['owner', 'admin'],
        subMenus: [{
          name: 'My Profile',
          svg: icons.profile,
          path: '/profile',
          roles: ['owner'],
        },
        {
          name: 'Manage Companies',
          svg: icons.company,
          path: '/company-management',
          roles: ['owner'],
          isSecondaryOwnerRestricted: true
        },
        {
          name: 'Manage Entities',
          svg: icons.entity,
          path: '/entity',
          roles: ['owner'],
          requiresSecondaryOwnerAccess: true,
          requiresUserManagementAccess: true
        },
        {
          name: 'Manage Users',
          svg: icons.users,
          path: '/user-management',
          roles: ['owner'],
          requiresUserManagementAccess: true
        },
        {
          name: 'Tag Management',
          svg: icons.dashboardTags,
          path: '/tag',
          roles: ['owner', 'admin'],
          requiresPaid: true,
          requiresSecondaryOwnerAccess: true
        },
        {
          name: 'Manage Vouchers',
          svg: icons.voucher,
          path: '/voucher',
          roles: ['owner'],
          requiresNoDemo: true,
          requiresPaid: true,
          requiresSecondaryOwnerAccess: true
        },
        {
          name: 'Petty Expense Categories',
          svg: icons.pettyExpense,
          path: '/petty-expense/category-management',
          roles: ['owner'],
          requiresSecondaryOwnerAccess: true,
          isSecondaryOwnerRestricted: true
        },
        {
          name: 'Petpooja POSS',
          svg: icons.p2poss,
          roles: ['owner', 'admin'],
          requiresPaid: true,
          featureFlag: 'showPushToPetpooja',
          subMenus: [{
            name: 'Push To Petpooja POSS',
            svg: icons.p2poss,
            path: '/push-to-petpooja',
            roles: ['owner', 'admin'],
            featureFlag: 'showPushToPetpooja',
            requiresSecondaryOwnerAccess: true
          },
          {
            name: 'Manage Tags',
            svg: icons.p2poss,
            path: '/push-to-petpooja/manage-poss-tags',
            roles: ['owner', 'admin'],
            featureFlag: 'showPushToPetpooja',
            requiresSecondaryOwnerAccess: true
          }
          ]
        },
        {
          name: 'Petpooja Invoice',
          svg: icons.p2Invoice,
          roles: ['owner', 'admin'],
          requiresPaid: true,
          featureFlag: 'showPushToRetailPos',
          subMenus: [{
            name: 'Push to Petpooja Invoice',
            svg: icons.p2Invoice,
            path: '/push-to-retail-pos',
            roles: ['owner', 'admin'],
            featureFlag: 'showPushToRetailPos'
          },
          {
            name: 'Manage Tags',
            svg: icons.p2Invoice,
            path: '/push-to-retail-pos/manage-invoice-tags',
            roles: ['owner', 'admin'],
            featureFlag: 'showPushToRetailPos'
          }]
        },
        {
          name: 'Tally ERP',
          svg: icons.p2Tally,
          roles: ['owner', 'admin'],
          requiresPaid: true,
          featureFlag: 'showPushToTally',
          subMenus: [{
            name: 'Push to Tally ERP',
            svg: icons.p2Tally,
            path: '/push-to-tally',
            roles: ['owner', 'admin'],
            featureFlag: 'showPushToTally'
          },
          {
            name: 'Manage Tags',
            svg: icons.p2Tally,
            path: '/tally-config',
            roles: ['owner', 'admin'],
            featureFlag: 'showPushToTally'
          }]
        }
          // {
          //     name: 'Billing & Payments',
          //     svg: icons.billing,
          //     path: '/billing'
          // }
        ]
      }]
    }
  ];

  AI_EXTRACTION_PROMPTS = [
    {
      id: 'UNIT_SEPARATION_PROMPT',
      label: 'Units Separation',
      prompt: "You are an expert Goods & Services Description analyzer.\nFor each input product string, you must extract 6 fields:\n1. purchase_unit: The purchase packaging unit exactly as written (e.g., Pack, Pc, Carton, Bottle, Can, Tin, etc.).\n2. purchase_qty_low: The lower numeric quantity for the purchase_unit.\n3. purchase_qty_high: The higher numeric quantity for the purchase_unit.\n4. content_unit: The unit of measurement of the product contents exactly as written (e.g., gm, Kg, ml, L, Inch, etc.).\n5. content_qty_low: The lower numeric quantity for the content_unit.\n6. content_qty_high: The higher numeric quantity for the content_unit.\n\nRules to follow:\n1. Do not modify or normalize the unit text.\n2. If any of the units or quantities are not present, return empty string \"\".\n3. For purchase_unit:\n- Always return purchase unit only if present.\n- If no packaging unit is present, return \"\".\n4. For purchase quantities:\n- Always return only numbers (no unit labels).\n- If there is a range like \"2 - 4 Pc\":\n    a) Return the lower value as purchase_qty_low (e.g., \"2\")\n    b) Return the higher value as purchase_qty_high (e.g., \"4\")\n- If there is a single quantity like \"6 Pc\":\n    a) set both low and high to 6.\n5. For content_unit:\n- Always return the final normalized unit (e.g., \"gm\") if mixed units exist.\n- Pick the smaller base unit if mixed units exist.\n- Return the unit as it is if mixed units does not exist (e.g. \"Kg\" for \"Pineapple/Ananasa Big (0.8 - 1.25 Kg), 1 Pc\").\n6. For content quantities:\n- Always return only numbers (no unit labels).\n- If there is a range like \"700 gm - 1.25 Kg\":\n    a) Normalize both sides into the same smaller unit (gm in this case).\n    b) Convert higher units if needed (1.25 Kg → 1250 gm).\n    c) Return the lower value as content_qty_low (e.g., \"700\")\n    d) Return the higher value as content_qty_high (e.g., \"1250\")\n- If there is a single quantity like \"500 gm\":\n    a) set both low and high to 500.\n7. If a unit is followed by a packaging word (Pack, Tin, Bottle, Carton, Pc, etc.), then:\n- The content_qty + content_unit come from the numeric value + measurement unit (15 L, 2 Kg).\n- The purchase_unit is only the packaging word (Tin, Pack).\n- The purchase_qty_low and purchase_qty_high should be 1 (because it means one Pack/Tin containing that much content).\n8. Do not return quantities with units combined. Separate them into qty and unit.\n9. Do not add explanations or extra words.\n10. Always Return a valid JSON object like this:\n{\"purchase_unit\": \"...\", \"purchase_qty_low\": \"...\", \"purchase_qty_high\": \"...\", \"content_unit\": \"...\", \"content_qty_low\": \"...\", \"content_qty_high\": \"...\"}\n\n--- MAPPING: map extracted units to GLOBAL_UNITS (this section MUST come last and be followed exactly) ---\n\nAfter extracting the raw purchase_unit and content_unit values above, MAP them to one of the following GLOBAL_UNITS. The final values returned in the JSON for purchase_unit and content_unit MUST be taken from this list (exact spelling and casing):\n\nGLOBAL_UNITS = ['Bag', 'Bundles', 'Bale', 'Buckles', 'Billions Of Units', 'Box', 'Bottles', 'Bunches', 'Cubic Meter', 'Cubic Centimeter', 'Cans', 'Cartons', 'Dozen', 'Drum', 'Great Gross', 'Gross', 'Numbers', 'Packs', 'Pieces', 'Pairs', 'Rolls', 'Sets', 'Tablets', 'Ten Gross', 'Thousands', 'Tubes', 'Units', 'Kilo Liter', 'Milliliter', 'US Gallons', 'Square Feet', 'Square Meters', 'Square Yards', 'Gross Yards', 'Kilo Meter', 'Meters', 'Yards', 'Centimeter', 'Tonnes', 'Quintal', 'Grams', 'Kilo Grams', 'Litres', 'Metricton']\n\nCRITICAL MAPPING RULES:\n1. Unit Type Determination First:\n- Packaging units (countable items): Packs, Pieces, Bottles, Cans, Cartons, Box, etc.\n- Content units (measurements): Grams, Kilo Grams, Litres, Milliliter, Meters, etc.\n- NEVER use the same unit type for both purchase_unit and content_unit\n2. Strict Packaging Unit Mapping:\n- \"pc\", \"pcs\", \"piece\", \"pieces\" → \"Pieces\"\n- \"pack\", \"packs\", \"packet\", \"pkts\" → \"Packs\"\n- \"bottle\", \"bottles\" → \"Bottles\"\n- \"can\", \"cans\", \"tin\", \"tins\" → \"Cans\"\n- \"carton\", \"cartons\" → \"Cartons\"\n- \"box\", \"boxes\" → \"Box\"\n- \"tray\", \"trays\" → \"\" (NOT in GLOBAL_UNITS)\n- \"pouch\", \"pouches\" → \"\" (NOT in GLOBAL_UNITS)\n3. Strict Content Unit Mapping:\n- \"gm\", \"g\", \"gram\", \"grams\" → \"Grams\"\n- \"kg\", \"kgs\", \"kilogram\", \"kilograms\" → \"Kilo Grams\"\n- \"l\", \"litre\", \"liter\", \"litres\", \"liters\" → \"Litres\"\n- \"ml\", \"mls\", \"millilitre\", \"milliliter\" → \"Milliliter\"\n- \"mm\", \"millimeter\", \"millimeters\" → \"\" (NOT in GLOBAL_UNITS)\n- \"cm\", \"centimeter\", \"centimeters\" → \"Centimeter\"\n- \"m\", \"meter\", \"meters\" → \"Meters\"\n- \"ft\" → \"Litres\"\n4. Priority Rules:\n- If both packaging and content units exist, purchase_unit gets packaging unit, content_unit gets measurement unit\n- If only measurement unit exists and no packaging unit, purchase_unit should be \"\" and content_unit gets measurement unit\n- If only packaging unit exists and no measurement unit, purchase_unit gets packaging unit, content_unit should be \"\"\n- NEVER assign the same unit type to both fields (e.g., Kilo Grams in both purchase_unit and content_unit)\n5. Exclusion Enforcement:\n- If a unit is NOT in GLOBAL_UNITS list, return \"\" for that field\n- Common exclusions: \"Tray\", \"Pouch\", \"mm\", \"jar\", \"container\" etc.\n6. Plural Form Preference:\n- Always use the plural form as specified in GLOBAL_UNITS when available\n\nExamples (model must follow these formats exactly):\nInput: \"Cabbage/Kobi (700 gm - 1.25 Kg), 1 Pc\",\nCorrected: {\"purchase_unit\": \"Pieces\", \"purchase_qty_low\": \"1\", \"purchase_qty_high\": \"1\", \"content_unit\": \"Grams\", \"content_qty_low\": \"700\", \"content_qty_high\": \"1250\"}\n\nInput: \"Cauliflower (Mixed Grade), 1.8 - 2.25 Kg (4-8 Pc)\",\nCorrected: {\"purchase_unit\": \"Pieces\", \"purchase_qty_low\": \"4\", \"purchase_qty_high\": \"8\", \"content_unit\": \"Kilo Grams\", \"content_qty_low\": \"1.8\", \"content_qty_high\": \"2.25\"}\n\nInput: \"Baby Corn Peeled, 200 gm (Pack of 1)\"\nCorrected: {\"purchase_unit\": \"Packs\", \"purchase_qty_low\": \"1\", \"purchase_qty_high\": \"1\", \"content_unit\": \"Grams\", \"content_qty_low\": \"200\", \"content_qty_high\": \"200\"}\n\nInput: \"Shaker Glass With Lid, 350 ml (Pack of 50)\"\nCorrected: {\"purchase_unit\": \"Packs\", \"purchase_qty_low\": \"50\", \"purchase_qty_high\": \"50\", \"content_unit\": \"Milliliter\", \"content_qty_low\": \"350\", \"content_qty_high\": \"350\"}\n\nInput: \"Sunrich - Refined Sunflower Oil, 15 L Tin\"\nCorrected: {\"purchase_unit\": \"Cans\", \"purchase_qty_low\": \"1\", \"purchase_qty_high\": \"1\", \"content_unit\": \"Litres\", \"content_qty_low\": \"15\", \"content_qty_high\": \"15\"}\n\nInput: \"Amul - French Fries 9 mm, 2.5 Kg\"\nCorrected: {\"purchase_unit\": \"\", \"purchase_qty_low\": \"\", \"purchase_qty_high\": \"\", \"content_unit\": \"Kilo Grams\", \"content_qty_low\": \"2.5\", \"content_qty_high\": \"2.5\"}\n\nInput: \"Eggs (30 Pcs/ Tray)\"\nCorrected: {\"purchase_unit\": \"Pieces\", \"purchase_qty_low\": \"30\", \"purchase_qty_high\": \"30\", \"content_unit\": \"\", \"content_qty_low\": \"\", \"content_qty_high\": \"\"}\n\nInput: \"Sarwar - Potato Starch, 1 Kg\"\nCorrected: {\"purchase_unit\": \"\", \"purchase_qty_low\": \"\", \"purchase_qty_high\": \"\", \"content_unit\": \"Kilo Grams\", \"content_qty_low\": \"1\", \"content_qty_high\": \"1\"}\n\nYou will be given a product string now."
    },
    {
      id: 'SIZE_MERGING_PROMPT',
      label: 'Size Merging',
      prompt: "You are an invoice data processing system. You are NOT allowed to infer, guess, extract, or hallucinate any values from descriptions.\n\nYou will receive:\n1. A list of Goods & Service Descriptions (plain text).\n2. A Product Table (dictionary) with column headers and row values.\n\nSTRICT VALIDATION STEP (MANDATORY):\n\nStep 1 — Check if a Size-related column EXISTS in the Product Table:\nA column is ONLY valid if:\n- Its header contains:\n  \"Size\", \"SZ\", \"S/Size\", etc.\n- AND at least ONE row in that column contains a real non-empty size value.\n\nIMPORTANT ROW RULES:\n- Row index \"0\" represents the HEADER/column name, not real data.\n- You MUST IGNORE row \"0\" completely.\n- Real data rows start from index \"1\".\n\nIf the column contains only header values in row \"0\" and no real data in rows \"1+\" → treat it as NOT FOUND.\n\nIf this condition is NOT satisfied:\n→ You MUST immediately return ONLY this output:\n\n{}\n\nABSOLUTE RULES:\n- You are NOT allowed to extract size values from descriptions.\n- You are NOT allowed to guess size values.\n- You are NOT allowed to simulate or assume columns that do not exist.\n- If size patterns (e.g., \"SZ-\", \"MM\", \"CM\", \"X\", \"ML\", \"KG\") appear only inside descriptions and not in a real column → return {}.\n\nOnly if a real Size column exists with real data, proceed.\n\nWHEN PROCEEDING:\n- Read sizes ONLY from the Product Table column.\n- NEVER read size from description text.\n- IGNORE row \"0\" of every column.\n- Use row alignment as primary matching logic.\n- Use text similarity only as a fallback.\n\nKEY FORMATTING RULES:\n- Keys MUST start from \"1\".\n- NEVER output \"0\" as a key.\n- Total keys must exactly match the number of descriptions.\n\nFor missing size values:\n- Output empty string \"\" in the size map.\n- Leave description unchanged.\n\nDESCRIPTION MODIFICATION RULES:\n- Append size only in this format:\n  <original description> - <size_value>\n- If size is empty → do NOT append dash, keep description unchanged.\n- If the size is a range like \"100 - 95\", normalize it to \"100-95\".\n\nFINAL OUTPUT FORMAT (ONLY if Size column exists):\n{\n  \"<exact_size_column_name>\": {\n    \"1\": \"<size_value_for_first_row>\",\n    \"2\": \"<size_value_for_second_row>\",\n    ...\n  },\n  \"DESCRIPTION_with_SIZE\": {\n    \"1\": \"<modified description for first item with correct Size>\",\n    \"2\": \"<modified description for first item with correct Size>\",\n    ...\n  }\n}"
    },
    {
      id: 'PART_NUMBER_MERGING_PROMPT',
      label: 'Part Number Merging',
      prompt: "You are an invoice data processing system. You are NOT allowed to infer, guess, extract, or hallucinate any values from descriptions.\n\nYou will receive:\n1. A list of Goods & Service Descriptions (plain text).\n2. A Product Table (dictionary) with column headers and row values.\n\nSTRICT VALIDATION STEP (MANDATORY):\n\nStep 1 — Check if a Part Number–related column EXISTS in the Product Table:\nA column is ONLY valid if:\n- Its header contains:\n  \"Part No\", \"Part Number\", \"Part No.\", etc.\n- AND at least ONE row in that column contains a real non-empty value.\n\nIMPORTANT ROW RULES:\n- Row index \"0\" represents the HEADER/column name, not real data.\n- You MUST IGNORE row \"0\" completely.\n- Real data rows start from index \"1\".\n\nIf the column contains only header values in row \"0\" and no real data in rows \"1+\" → treat it as NOT FOUND.\n\nIf this condition is NOT satisfied:\n→ You MUST immediately return ONLY this output:\n\n{}\n\nABSOLUTE RULES:\n- You are NOT allowed to extract part numbers from descriptions.\n- You are NOT allowed to guess part numbers.\n- You are NOT allowed to simulate or assume columns that do not exist.\n- If numeric or alphanumeric codes appear only inside descriptions and not in a real column → return {}.\n\nOnly if a real Part Number column exists with real data, proceed.\n\nWHEN PROCEEDING:\n- Read part numbers ONLY from the Product Table column.\n- NEVER read part numbers from description text.\n- IGNORE row \"0\" of every column.\n- Use row alignment as primary matching logic.\n- Use text similarity only as a fallback when absolutely necessary.\n\nKEY FORMATTING RULES:\n- Keys MUST start from \"1\".\n- NEVER output \"0\" as a key.\n- Total keys must exactly match the number of descriptions.\n\nFor missing part numbers:\n- Output empty string \"\" in the part number map.\n- Leave description unchanged.\n\nDESCRIPTION MODIFICATION RULES:\n- Append part number only in this exact format:\n  <original description> <part_number_value>\n- If part number is empty → do NOT append space, keep description unchanged.\n\nFINAL OUTPUT FORMAT (ONLY if Part Number column exists):\n{\n  \"<exact_part_number_column_name>\": {\n    \"1\": \"<part_number_value_for_first_row>\",\n    \"2\": \"<part_number_value_for_second_row>\",\n    ...\n  },\n  \"DESCRIPTION_with_PART_NO\": {\n    \"1\": \"<modified description for first item with correct Part Number>\",\n    \"2\": \"<modified description for second item with correct Part Number>\",\n    ...\n  }\n}"
    },
    {
      id: 'MRP_MERGING_PROMPT',
      label: 'MRP Merging',
      prompt: "You are an invoice data processing system. You are NOT allowed to infer, guess, extract, or hallucinate any values from descriptions.\n\nYou will receive:\n1. A list of Goods & Service Descriptions (plain text).\n2. A Product Table (dictionary) with column headers and row values.\n\nSTRICT VALIDATION STEP (MANDATORY):\n\nStep 1 — Check if an MRP-related column EXISTS in the Product Table:\nA column is ONLY valid if:\n- Its header contains:\n  \"MRP\", \"M.R.P\", \"MAX RETAIL PRICE\", \"PRICE (MRP)\", etc.\n- AND at least ONE row in that column contains a real non-empty numeric value.\n\nIMPORTANT ROW RULES:\n- Row index \"0\" represents the HEADER/column name, not real data.\n- You MUST IGNORE row \"0\" completely.\n- Real data rows start from index \"1\".\n\nIf the column contains only header values in row \"0\" and no real data in rows \"1+\" → treat it as NOT FOUND.\n\nIf this condition is NOT satisfied:\n→ You MUST immediately return ONLY this output:\n\n{}\n\nABSOLUTE RULES:\n- You are NOT allowed to extract MRP values from descriptions.\n- You are NOT allowed to guess MRP values.\n- You are NOT allowed to simulate or assume columns that do not exist.\n- If price-like numbers appear only inside descriptions and not in a real column → return {}.\n\nOnly if a real MRP column exists with real data, proceed.\n\nWHEN PROCEEDING:\n- Read MRP values ONLY from the Product Table column.\n- NEVER read MRP from description text.\n- IGNORE row \"0\" of every column.\n- Use row alignment as primary matching logic.\n- Use text similarity only as a fallback when absolutely necessary.\n\nKEY FORMATTING RULES:\n- Keys MUST start from \"1\".\n- NEVER output \"0\" as a key.\n- Total keys must exactly match the number of descriptions.\n\nFor missing MRP values:\n- Output empty string \"\" in the MRP map.\n- Leave description unchanged.\n\nMRP NORMALIZATION RULES FOR DESCRIPTION:\n- If MRP is \"139.00\" → use \"MRP-139\"\n- If MRP is \"220.25\" → use \"MRP-220.25\"\n- Preserve original decimal value in the MRP column object.\n\nDESCRIPTION MODIFICATION RULES:\n- Append MRP only in this exact format:\n  <original description> - MRP-<value>\n- If MRP value is empty → do NOT append anything.\n\nFINAL OUTPUT FORMAT (ONLY if MRP column exists):\n{\n  \"<exact_mrp_column_name>\": {\n    \"1\": \"<mrp_value_for_first_row>\",\n    \"2\": \"<mrp_value_for_second_row>\",\n    ...\n  },\n  \"DESCRIPTION_with_MRP\": {\n    \"1\": \"<modified description for first item with correct MRP>\",\n    \"2\": \"<modified description for second item with correct MRP>\",\n    ...\n  }\n}"
    },
    {
      id: 'ITEM_NARRATION_PROMPT',
      label: 'Item Narration',
      prompt: "You are an expert Goods & Services Description analyzer.\n\nTask:\nSplit the given product string into two parts:\n1. \"product_name\": the exact main Goods or Service name that appears **visually bold, highlighted, or more prominent** in the PRODUCT TABLE image.\n2. \"Narration\": the remaining narrative text that follows the main product name in the same cell or line, usually written in **lighter or less bold font**.\n\nRules:\n1. Use the PRODUCT TABLE image only to identify **where the bold or prominent part (product_name)** ends and where the lighter narration begins.\n2. Use the given product string only to determine **what text** to extract — do not rephrase, correct, or remove words.\n3. The product_name is always at the **start** of the product string, and the narration always follows it.\n4. Preserve the **exact casing, punctuation, and spacing** of the original string.\n5. Never use any other table columns from the image — only the “Description” column.\n6. The split point must occur **exactly once** if narration is there after product_name.\n7. Always return valid JSON strictly in this format:\n{\"product_name\": \"...\", \"Narration\": \"...\"}\n\nYou will be given a product string now."
    },
    {
      id: 'HSN_CODE_EXTRACTION_PROMPT',
      label: 'HSN Code Extraction',
      prompt: "You are an expert HSN Code Extractor from invoice item descriptions.\n\nYou will receive:\n- A list of Goods & Service Descriptions extracted as plain text (text_list).\n\nYour task:\n- Extract HSN codes ONLY if they are explicitly present in the text.\n\nSTRICT GLOBAL VALIDATION STEP (MANDATORY):\n\nStep 1 — Scan the ENTIRE list and check if at least ONE REAL HSN code exists.\n\nA \"real\" HSN code MUST satisfy ALL conditions:\n- Must be **exactly 4, 6, or 8 digits**\n- Must NOT be part of quantity, price, date, phone number, pincode, invoice number, or any random long number\n- Must be logically related to product/tax classification based on context keywords like: HSN, HSNCODE, H.S.N, CODE\n\nIf **ZERO real HSN codes** are found in the complete list:\n→ You MUST return ONLY this exact output and NOTHING else:\n\n{}\n\nABSOLUTE RULES:\n- Do NOT return empty strings\n- Do NOT return null values\n- Do NOT return placeholders\n- Do NOT return the \"HSN_CODE\" object\n- Do NOT explain anything\n\nONLY IF at least ONE real HSN code is detected, proceed:\n\nRules when proceeding:\n1. Extract only CONTEXT-VALID HSN codes.\n2. Remove the HSN code from the product description when returning cleaned descriptions.\n3. If a specific description does not contain an HSN code, return the original description unchanged.\n4. If a specific description does not contain an HSN code, return an empty string \"\" for that item in HSN_CODE.\n5. Keep original order.\n6. Do not guess or infer.\n\nReturn valid JSON in this exact format ONLY when a real HSN exists:\n\n{\n  \"PRODUCT_DESCRIPTION_WITHOUT_HSN\": {\n    \"1\": \"<first description without HSN code or same string>\",\n    \"2\": \"<second description without HSN code or same string>\",\n    ...\n  },\n  \"HSN_CODE\": {\n    \"1\": \"<HSN code from first description or empty string>\",\n    \"2\": \"<HSN code from second description or empty string>\",\n    ...\n  }\n}\n\nRules for numbering:\n- Keys (\"1\", \"2\", \"3\", ...) must follow the order of the input descriptions.\n- Do not skip or repeat keys.\n- Ensure the JSON is valid and can be directly parsed by standard JSON parsers."
    },
    {
      id: 'BATCH_MANUFACTURING_EXPIRY_DATE_PROMPT',
      label: 'Batch, Manufacturing Date, Expiry Date Extraction',
      prompt: "You are an expert Batch, Manufacturing Date and Expiry Date extractor from invoice item descriptions.\n\nYou will receive:\n- A list of Goods & Service Descriptions extracted as plain text (text_list).\n\nYour task:\n- From each description, extract:\n  1) Batch Number\n  2) Mfg Date\n  3) Expiry Date\n\nSTRICT GLOBAL VALIDATION STEP (MANDATORY):\n\nStep 1 — Check whether ANY of the following exist in the ENTIRE list:\n- A valid Batch number\n- A valid Manufacturing date\n- A valid Expiry date\n\nVALID FORMATS:\n\nBatch Number:\n- Appears like: \"Batch :123456\", \"Batch: 73891\", etc.\n- Can be numeric or alphanumeric\n\nMfg Date:\n- Appears like: \"Mfg Dt. : 02-Mar-25\", \"Mfg Dt : 11-Nov-25\", etc.\n\nExpiry Date:\n- Appears like: \"Expiry : 26-Jan-25\", \"Expiry Dt : 25-Jul-26\", etc.\n\nIf NONE of these are found in ANY description:\n→ You MUST immediately return ONLY this output:\n\n{}\n\nABSOLUTE RULES:\n- Do NOT guess or hallucinate values.\n- Do NOT generate default dates.\n- Only extract values clearly present in text.\n\nONLY IF at least ONE valid Batch or Mfg or Expiry value is found, proceed.\n\nWHEN PROCEEDING:\n\nExtraction Rules:\n1. Extract exact values as they appear (preserve spaces, dashes and casing).\n2. If a value is NOT present in a description, return \"\".\n3. Do NOT modify or clean any values.\n4. Output order must match input order.\n\nReturn a valid JSON object in this exact format:\n\n{\n  \"BATCH_NUMBER\": {\n    \"1\": \"<batch value or empty string>\",\n    \"2\": \"<batch value or empty string>\",\n    ...\n  },\n  \"MFG_DATE\": {\n    \"1\": \"<mfg date or empty string>\",\n    \"2\": \"<mfg date or empty string>\",\n    ...\n  },\n  \"EXPIRY_DATE\": {\n    \"1\": \"<expiry date or empty string>\",\n    \"2\": \"<expiry date or empty string>\",\n    ...\n  }\n}\n\nRules for numbering:\n- Keys (\"1\", \"2\", \"3\", ...) must follow input order.\n- Do not skip or repeat keys.\n- Ensure valid JSON output only."
    },
    {
      id: 'SEPARATE_TAX_FROM_SINGLE_COLUMN',
      label: 'Separate Tax from Single Column',
      prompt: "Aggregate all GST tax values into one column called TOTAL_GST_RATE, and list the cess tax in a separate column called CESS_RATE."
    }
  ];

}
